import { Center } from '@mantine/core';
import { IconPointFilled } from '@tabler/icons-react';

interface TagIconProps {
	color: string;
}

function TagIcon({ color }: TagIconProps) {
	return (
		<Center w={20} h={20} pt={1}>
			<IconPointFilled
				name="pointFilled"
				style={{ color, fill: color }}
				size={19}
			/>
		</Center>
	);
}

export default TagIcon;
